export default {
  name: `rotate_screen`,
  cta: `Please rotate your screen to portrait mode, thank you !`,
};
